import { Merge } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import ToolPage from "./ToolPage";

export default function MergePDF() {
  const { t } = useLanguage();
  const tk = t.tools.merge;


  const config = {
    title: tk.title,
    description: tk.description,
    action: tk.action,
    hint: tk.dropHint,
    hintSub: tk.dropHintSub,
    endpoint: "/pdf/merge",
    accept: ".pdf",
    multiple: true,
    resultType: "download",
    resultFileName: tk.result,
    color: "#2563eb",
    Icon: Merge,
    toolKey: "merge",
  };

  return <ToolPage config={config} />;
}
